import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { companyLocalToIso, formatDispatchDate, formatDispatchTime } from "../lib/dispatch";

export function PastAppointmentWarning({ date, start, timezone }: { date: string; start: string; timezone: string }) {
  const [, tick] = useState(0);
  useEffect(() => {
    const timer = window.setInterval(() => tick((value) => value + 1), 30_000);
    return () => window.clearInterval(timer);
  }, []);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^\d{2}:\d{2}$/.test(start)) return null;
  const startsAt = companyLocalToIso(`${date}T${start}`, timezone);
  if (!(Date.parse(startsAt) < Date.now())) return null;
  return <div role="status" className="past-appointment-warning mb-3 flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-amber-950">
    <AlertTriangle size={18} className="mt-0.5 shrink-0" aria-hidden />
    <div><p className="text-sm font-semibold">Booking an appointment in the past</p>
      <p className="mt-0.5 text-xs">Selected start: {formatDispatchDate(startsAt, timezone, { month: "short", day: "numeric", year: "numeric" })} at {formatDispatchTime(startsAt, timezone)} ({timezone}).</p>
    </div>
  </div>;
}
